import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import messageHandler from 'utils/messageHandler';

const branchOfficeSlice = createSlice({
  name: 'branchOffice',
  initialState: {
    branchOffices: []
  },
  reducers: {
    setBranchOffices: (state, { payload }) => {
      state.branchOffices = payload;
    },
    setBranchOfficesToInitial: state => {
      state.branchOffices = [];
    }
  }
});

export const { setBranchOffices, setBranchOfficesToInitial } =
  branchOfficeSlice.actions;

export const getBranchOfficesByUserId = userId => async dispatch => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_SERVER}/branch-offices/user/${userId}`
    );

    dispatch(setBranchOffices(data));
  } catch (e) {
    console.log(e);
  }
};

export const setBranchToInitial = () => async dispatch => {
  dispatch(setBranchOfficesToInitial());
};

export const createBranchOffice = (name, realEstateId) => async () => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_SERVER}/branch-offices`,
      {
        branchOfficeName: name,
        realEstateId,
        isCentral: false,
        isActive: true
      }
    );

    messageHandler('success', response?.data?.message);

    return response;
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
  }
};

export const updateBranchOffice =
  (
    id,
    {
      barrio,
      email,
      openingHours,
      extraPhones,
      whatsapp,
      address,
      phoneNumber,
      name
    }
  ) =>
  async () => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_SERVER}/branch-offices/${id}`,
        {
          barrio,
          email,
          openingHours,
          extraPhones,
          whatsapp,
          address,
          phoneNumber,
          branchOfficeName: name
        }
      );

      messageHandler('success', response?.data?.message);

      return response;
    } catch (e) {
      messageHandler('error', e.response?.data?.message);
    }
  };

export const updatePropertiesStatus =
  // eslint-disable-next-line
  (branchOfficeId, status) => async dispatch => {
    const url = `${process.env.REACT_APP_SERVER}/branch-offices/change-status-properties/${branchOfficeId}`;

    try {
      const response = await axios.put(url, {
        status
      });
      return response;
    } catch (error) {
      return error.response;
    }
  };

export const updateProjectsStatus =
  // eslint-disable-next-line
  (branchOfficeId, status) => async dispatch => {
    const url = `${process.env.REACT_APP_SERVER}/branch-offices/change-status-projects/${branchOfficeId}`;

    try {
      const response = await axios.put(url, {
        status
      });
      return response;
    } catch (error) {
      return error.response;
    }
  };

export default branchOfficeSlice.reducer;
